import { BreadcrumbLoader } from "../../../../decorators/BreadcrumbLoader";
import { IBreadcrumbIconLoader } from "../../../../services/breadcrumbs/breadcrumbLoaders/breadcrumbIconLoaders/IBreadcrumbIconLoader";
import { IconName } from "@snpjs/core";
import { Routes } from "../../../../routes/Routes";

@BreadcrumbLoader(Routes.homePage.toPath())
export class HomeBreadcrumbIconLoader implements IBreadcrumbIconLoader {
  iconName: IconName = "house";
}
